import React from "react";

export default function Logo({ className = "h-12 w-auto", showTagline = true }) {
    return (
        <div className="flex flex-col items-start select-none">
            {/* Light Mode Logo */}
            <img
                src="/logo-light.png"
                alt="blinqbooks Logo"
                className={`${className} object-contain dark:hidden`}
            />
            {/* Dark Mode Logo */}
            <img
                src="/logo-dark.png"
                alt="blinqbooks Logo"
                className={`${className} object-contain hidden dark:block`}
            />
            {showTagline && (
                <span className="text-[7.5px] font-semibold tracking-[0.25em] text-brand-primary dark:text-[#49b1e9] mt-1 uppercase font-sans whitespace-nowrap block">
                    Made for Modern Accounting
                </span>
            )}
        </div>
    );
}
